


































































































































import Vue, { PropType } from 'vue'
import UiBadge from '../UiBadge'
import UiIcon from '../UiIcon'
import UiImage from '../UiImage'
import UiBuyButton from '../UiBuyButton'
import { ProductBoxData, ProductBoxImage } from './UiProductBox.types'

export default Vue.extend({
  name: 'UiProductBox',
  components: {
    UiBadge,
    UiIcon,
    UiImage,
    UiBuyButton
  },
  props: {
    content: {
      type: Object as PropType<ProductBoxData>,
      default: () => ({} as ProductBoxData)
    },
    image: {
      type: Object as PropType<ProductBoxImage>,
      default: () => ({} as ProductBoxImage)
    }
  },
  methods: {
    handleClick (): void {
      if (this.content.isAccessory && this.$gtm) {
        this.$gtm.push({
          event: 'user action',
          gaEventCategory: 'productview',
          gaEventAction: 'zubehoer', // VAR = overview / detail / zubehoer / ...
          gaEventLabel: this.content.header, // VAR = if overview = RT; RK; .. | if detail = RK1000 ...
          gaEventValue: '1' // Fest =  1
        })
      }
    }
  }
})
